import LoginLayout from "../../layouts/LoginLayout";
import LoginCard from "../../components/auth/LoginCard";

export default function Login() {
  return (
    <LoginLayout>
      <LoginCard />
    </LoginLayout>
  );
}
